if (typeof document === "undefined") return;
var createStylesheet = function (
	chunkId, fullhref, oldTag, resolve, reject
) {
	var linkTag = document.createElement("link");
	linkTag.setAttribute("data-vanilla-extract", "true");

	linkTag.rel = "stylesheet";
	linkTag.type="text/css";
	if (__webpack_require__.nc) {
		linkTag.nonce = __webpack_require__.nc;
	}
	var onLinkComplete = function (event) {
		// avoid mem leaks.
		linkTag.onerror = linkTag.onload = null;
		if (event.type === 'load') {
			resolve();
		} else {
			var errorType = event && (event.type === 'load' ? 'missing' : event.type);
			var realHref = event && event.target && event.target.href || fullhref;
			var err = new Error("Loading CSS chunk " + chunkId + " failed.\\n(" + realHref + ")");
			err.code = "CSS_CHUNK_LOAD_FAILED";
			err.type = errorType;
			err.request = realHref;
			if (linkTag.parentNode) linkTag.parentNode.removeChild(linkTag)
			reject(err);
		}
	}

	linkTag.onerror = linkTag.onload = onLinkComplete;
	linkTag.href = fullhref;
	if (linkTag.href.indexOf(window.location.origin + '/') !== 0) {
  linkTag.crossOrigin = "anonymous";
}
	if (oldTag) {
  oldTag.parentNode.insertBefore(linkTag, oldTag.nextSibling);
} else {
  document.head.appendChild(linkTag);
}
	return linkTag;
}
var findStylesheet = function (href, fullhref) {
	var existingLinkTags = document.getElementsByTagName("link");
	for (var i = 0; i < existingLinkTags.length; i++) {
		var tag = existingLinkTags[i];
		var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
		if (dataHref) {
			dataHref = dataHref.split('?')[0]
		}
		if (tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return tag;
	}

	var existingStyleTags = document.getElementsByTagName("style");
	for (var i = 0; i < existingStyleTags.length; i++) {
		var tag = existingStyleTags[i];
		var dataHref = tag.getAttribute("data-href");
		if (dataHref === href || dataHref === fullhref) return tag;
	}
}

var loadStylesheet = function (chunkId) {
	return new Promise(function (resolve, reject) {
		var href = __webpack_require__.miniCssF(chunkId);
		var fullhref = __webpack_require__.p + href;
		if (findStylesheet(href, fullhref)) return resolve();
		createStylesheet(chunkId, fullhref, null, resolve, reject);
	})
}

// object to store loaded CSS chunks
var installedCssChunks = {
	"3808": 0,

};

__webpack_require__.f.miniCss = function(chunkId, promises) {
	var cssChunks = {
"2450": 1,
"4197": 1,
"8517": 1,
"8143": 1,
"6908": 1,
"5981": 1,
"1889": 1,
"2867": 1,
"4434": 1,
"4126": 1,
"4873": 1,
"3421": 1,
"4298": 1,
"5438": 1,
"2197": 1,
"6890": 1,
"6740": 1,
"2074": 1,
"8549": 1,
"5763": 1,
"5708": 1,
"7234": 1,
"2614": 1,
"2600": 1,
"6011": 1,
"5854": 1,
"4637": 1,
"2268": 1,
"6615": 1,
"8552": 1,
"4849": 1,
"1757": 1,
"2309": 1,
"1524": 1,
"7492": 1,
"1499": 1,
"6650": 1,
"8825": 1,
"8043": 1,
"6940": 1,
"1206": 1,
"5401": 1,
"4976": 1,
"1159": 1,
"3693": 1,
"9654": 1,
"217": 1,
"9079": 1,
"8475": 1,
"1930": 1,
"5595": 1,
"9898": 1,
"6068": 1,
"4725": 1,
"2730": 1,
"6834": 1,
"5604": 1,
"5660": 1,
"7963": 1,
"4076": 1,
"5755": 1,
"7209": 1,
"3988": 1,
"5014": 1,
"2250": 1,
"439": 1,
"3485": 1,
"377": 1,
"2776": 1,
"5849": 1,
"7641": 1,
"2815": 1,
"6673": 1,

};
	if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId])
	else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId])
		promises.push(
			installedCssChunks[chunkId] = loadStylesheet(chunkId).then(
				function() {
					installedCssChunks[chunkId] = 0;
				},
				function(e) {
					delete installedCssChunks[chunkId];
					throw e;
				}
			)
		)
}

// no hmr
